import { v4 as uuid } from "uuid";

export default class DataStorage {
  static data = {};
  constructor(value) {
    this.id = uuid();
    this.value = value;
    this.constructor.data[this.id] = value;
  }

  static find(id) {
    return this.data[id] || "";
  }

  static create(data) {
    return new DataStorage(data).id;
  }
}
